import React from 'react';
export var Triangle = function Triangle(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'up' : _ref$type;
  return React.createElement("svg", {
    style: {
      transform: type === 'up' ? 'rotate(0deg)' : 'rotate(180deg)'
    },
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    className: "svg-triangle",
    width: "10",
    height: "10",
    fill: type === 'up' ? '#29cb82' : '#f94245'
  }, React.createElement("polygon", {
    points: "5,0 10,10 0,10"
  }));
};